<template>
  <div>
    <div class="topBackground">
      <img class="logn" src="../../assets/img/Logo.png"></img>
    </div>
    <div class="inputBackground">
      <div class="inputCenter">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
          status-icon>
          <el-form-item prop="username" class="formInput">
            <el-input v-model="dataForm.username" :placeholder="$t('login.username')" class="inputStyle" size=""
              :validate-event	="false">
              <span slot="prefix" class="el-input__icon">
                <svg class="icon-svg iconImg" aria-hidden="true">
                  <use xlink:href="#icon-user"></use>
                </svg>
              </span>
            </el-input>
          </el-form-item>
          <el-form-item prop="password" class="formInput">
            <el-input v-model="dataForm.password" type="password" :placeholder="$t('login.password')" class="inputStyle"
              :validate-event	="false">
              <span slot="prefix" class="el-input__icon">
                <svg class="icon-svg iconImg" aria-hidden="true">
                  <use xlink:href="#icon-lock"></use>
                </svg>
              </span>
            </el-input>
          </el-form-item>
          <!-- <el-form-item prop="captcha">
                <el-row :gutter="20">
                  <el-col :span="14">
                    <el-input v-model="dataForm.captcha" :placeholder="$t('login.captcha')">
                      <span slot="prefix" class="el-input__icon">
                        <svg class="icon-svg" aria-hidden="true">
                          <use xlink:href="#icon-safetycertificate"></use>
                        </svg>
                      </span>
                    </el-input>
                  </el-col>
                  <el-col :span="10" class="login-captcha">
                    <img :src="captchaPath" @click="getCaptcha()" />
                  </el-col>
                </el-row>
              </el-form-item>  -->
          <el-form-item>
            <el-button type="primary" @click="dataFormSubmitHandle()" class="loginStyle"
              style="background: #4d71b8;border-color: #4d71b8;">{{
                $t('login.title')
              }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import debounce from 'lodash/debounce';
import { getUUID } from '@/utils';
export default {
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('年龄不能为空'));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'));
        } else {
          if (value < 18) {
            callback(new Error('必须年满18岁'));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    return {
      captchaPath: '',
      dataForm: {
        username: '',
        password: '',
        uuid: '',
        // captcha: '123456',
      },

      dataRule: {
        username: [
          {
            required: true,
            message: this.$t('validate.required'),
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('validate.required'),
          },
        ],
      },
    };
  },
  computed: {
  },
  created() {
    this.getCaptcha();
  },
  methods: {
    // 获取验证码
    getCaptcha() {
      this.dataForm.uuid = getUUID();
      this.captchaPath = `${window.SITE_CONFIG['apiURL']}/captcha?uuid=${this.dataForm.uuid}`;
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.$http
            .post('/login', this.dataForm)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                this.getCaptcha();
                return this.$message.error(res.msg);
              }
              Cookies.set('token', res.data.token);
              this.$router.replace({ name: 'informationInquiry-index' });
              // this.$router.replace({ name: 'home' });
            })
            .catch(() => { });
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>
<style scoped >
.topBackground {
  max-height: 65vh;
  height: 65vh;
  background-image: url(../../assets/img/topbackground.png);
  background-size: 100%100%;
  position: relative;
}

.logn {
  position: absolute;
  top: 3%;
  left: 3%;
  height: 100px;
  width: 13 0px;
}

.inputBackground {
  /* width: 100vw; */
  /* min-height: 30vh; */
  /* width: 100%;
  max-height: 20vh; */
}

.inputCenter {
  width: 400px;
  height: 100%;
  margin: 0 auto;
  padding-top: 1.5%;
}

.loginStyle {
  height: 40px;
  width: 100%;
  border-radius: 10px;
  font-size: 24px;
  padding: 0;
  font-family: 'fontStyle';
}

.iconImg {
  width: 30px;
  height: 30px;
  color: #5261ad;
}

.inputStyle {
  height: 40px;
  /* border: 1px solid #5261ad; */
}
</style>
<style>
.inputStyle .el-input__inner {
  /* height: 100% !important; */
  padding-left: 50px;
  border: 2px solid #5261ad;
  border-radius: 10px;
}

.formInput {
  margin-bottom: 6%;
  /* border: 1px solid #5261ad; */
  border-radius: 10px;
}

.inputStyle .el-input__inner input.invalid:focus {
  border-color: #5261ad;
}
</style>
